import { render, staticRenderFns } from "./LogisticUpdates.vue?vue&type=template&id=e5d3c30e&"
import script from "./LogisticUpdates.vue?vue&type=script&lang=js&"
export * from "./LogisticUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports